// Used in lots of JS, including general.js and uncompiled admin scripts
window.loader = (function () {
    const loaderDots = "<div role='alert' aria-label='loading' class='dot one'></div><div class='dot two'></div><div class='dot three'></div>";
    const loader = "<div role='alert' aria-label='loading' class='loader'>" + loaderDots + '</div>';
    const pageLoader = "<div role='alert' aria-label='loading' class='loader page-loader'>" + loaderDots + '</div>';

    const result = {};

    result.showPageLoader = function () {
        $('body').append(pageLoader);
    };

    result.showPageLoaderAndShield = function () {
        $('body').append("<div class='shield'></div>" + pageLoader);
    };

    result.showPageLoaderAndHidePage = function (message) {
        $('body').append("<div class='shield'></div>" + pageLoader);
        $('.shield').addClass('hide-page');
        if (message) {
            const messageString = (message) ? "<div class='message'>" + message + '</div>' : '';
            $('.page-loader').append(messageString);
        }
    };

    result.showLoader = function (target, customClass) {
        $(target).append(loader);
        if (customClass) {
            const $thisLoader = $(target).find('.loader');
            $thisLoader.addClass(customClass);
        }
    };

    result.showLoaderAfter = function (target, customClass) {
        $(target).after(loader);
        if (customClass) {
            const $thisLoader = $(target).next('.loader');
            $thisLoader.addClass(customClass);
        }
    };

    result.removeLoader = function () {
        $('.loader').remove();
        $('.shield').remove();
    };

    result.removeChildLoader = function (target) {
        const $childLoader = $(target).find('.loader');
        $childLoader.remove();
    };

    return result;
})();
